
import { h } from "@stencil/core"

const GreenCheck = ():SVGElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="12 12 16 16">
      <path d="M28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28C24.4183 28 28 24.4183 28 20Z" fill="#0CD185"/>
      <path d="M16 20.468L18.137 22.963C18.2392 23.0824 18.3681 23.1761 18.5132 23.2364C18.6584 23.2967 18.8157 23.3219 18.9724 23.31C19.1292 23.2981 19.2809 23.2495 19.4153 23.168C19.5497 23.0865 19.663 22.9745 19.746 22.841L24 16" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>
  );
};
export default GreenCheck;
